import * as React from "react";
const SvgMicrophone = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M15.8337 8.33268V9.99935C15.8337 13.221 13.222 15.8327 10.0003 15.8327M4.16699 8.33268V9.99935C4.16699 13.221 6.77866 15.8327 10.0003 15.8327M10.0003 15.8327V18.3327M6.66699 18.3327H13.3337M12.5003 4.99935H10.8337M12.5003 8.33268H10.8337M10.0003 12.4993C8.61961 12.4993 7.50033 11.3801 7.50033 9.99935V4.16602C7.50033 2.7853 8.61961 1.66602 10.0003 1.66602C11.381 1.66602 12.5003 2.7853 12.5003 4.16602V9.99935C12.5003 11.3801 11.381 12.4993 10.0003 12.4993Z",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgMicrophone;
